/**
 * AppealSlice Policy Reducers
 * 
 * Reducers for managing policy references.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { PolicyReferenceView } from '../../types/appealTypes';
import { AppealSliceState } from '../state';

// =============================================================================
// POLICY REFERENCE REDUCERS
// =============================================================================

/**
 * Add a policy reference to the selection
 */
export const addPolicyReference: CaseReducer<AppealSliceState, PayloadAction<PolicyReferenceView>> = (
  state,
  action
) => {
  state.selectedPolicyReferences.push(action.payload);
  if (state.currentAppeal) {
    state.currentAppeal.policyReferences = state.selectedPolicyReferences;
    state.hasUnsavedChanges = true;
  }
};

/**
 * Remove a policy reference by ID
 */
export const removePolicyReference: CaseReducer<AppealSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  state.selectedPolicyReferences = state.selectedPolicyReferences.filter(
    p => p.id !== action.payload
  );
  if (state.currentAppeal) {
    state.currentAppeal.policyReferences = state.selectedPolicyReferences;
    state.hasUnsavedChanges = true;
  }
};

/**
 * Clear all policy references
 */
export const clearPolicyReferences: CaseReducer<AppealSliceState> = (state) => {
  state.selectedPolicyReferences = [];
  if (state.currentAppeal) {
    state.currentAppeal.policyReferences = [];
    state.hasUnsavedChanges = true;
  }
};
